<template>

    <v-menu offset-y left
      :close-on-content-click="false"
      transition="scale-transition"
    >
      <v-btn slot="activator" flat color="info">
        <v-icon large>account_circle</v-icon>
      </v-btn>
       <v-list>
         <v-subheader>{{ userMail }} </v-subheader>
         <v-list-tile
            @click="goProfile()"
            >
            <v-list-tile-action>
              <v-icon>face</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Mon Profil</v-list-tile-title>
            </v-list-tile-content>

           
          </v-list-tile>
          <v-list-tile
            @click="logout()"
            >
            <v-list-tile-action>
              <v-icon>logout</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>Se déconnecter</v-list-tile-title>
            </v-list-tile-content>

           
          </v-list-tile>
        </v-list>
    </v-menu>
 
</template>





<script>
import {  mapState } from 'vuex';

export default {
  data() {
    return {
      dialog: false,
    };
  },
    computed: mapState('auth', [
    'authenticating',
    'error',
    'token',
    'userMail',
  ]),

  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
        .then(() => this.$router.push('/'));
    },
    goProfile() {
      this.$router.push('/profil');
    },
  }
};
</script>

